import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SurveyPeriodsList from './SurveyPeriodsList';
import SurveyPeriodCreatePage from './SurveyPeriodCreatePage';
import SurveyPeriodEditPage from './SurveyPeriodEditPage';

const SurveyPeriodRoutes = () => {
  return (
    <Routes>
      <Route index element={<SurveyPeriodsList />} />
      <Route path="new" element={<SurveyPeriodCreatePage />} />
      <Route path=":id/edit" element={<SurveyPeriodEditPage />} />
    </Routes>
  );
};

export default SurveyPeriodRoutes;